import React from "react";
import "./OurMission.css";

const OurMission = () => {
  return (
    <section className="OurMission">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="text-holder">
              <h2 className="heading">Our Mission and Vision</h2>
            </div>

            <div className="main-content-holder">
              <div className="content-holder">
                <div className="row">
                  <div className="col-xl-3 col-md-4 col-6 mx-auto">
                    <div className="img-main-holder">
                      <div className="img-holder">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/Assets/Images/AboutUs/OurMission/img1.png"
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-9 col-md-8">
                    <div className="text-container">
                      <div className="text-holder">
                        <h3 className="title">
                          Our <span>Mission</span>
                        </h3>
                        <div className="descriptiuon">
                          <p>
                            <b>At ReachOut Media Tech Pvt. Ltd.</b>, our mission
                            is to empower brands with innovative, impactful, and
                            accessible advertising solutions. By blending
                            creativity, technology, and strategy, we aim to
                            deliver campaigns that connect businesses to their
                            audiences, inspire action, and drive measurable
                            results.
                          </p>
                          <br />
                          <p>
                            We are committed to breaking barriers in the
                            advertising industry by reaching urban and rural
                            communities alike, ensuring every brand we work with
                            has a platform to shine.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="main-content-holder">
              <div className="content-holder">
                <div className="row">
                  <div className="col-xl-3 col-md-4 col-6 mx-auto">
                    <div className="img-main-holder">
                      <div className="img-holder">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/Assets/Images/AboutUs/OurMission/im2.png"
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-9 col-md-8">
                    <div className="text-container">
                      <div className="text-holder">
                        <h3 className="title">
                          Our <span>Vision</span>
                        </h3>
                        <div className="descriptiuon">
                          <p>
                            To become a trailblazer in the advertising industry
                            by setting new benchmarks for creativity,
                            innovation, and excellence.
                          </p>
                          <br />
                          <p>
                            We envision a future where ReachOut transforms every
                            public & private space into a canvas for brands to
                            tell their stories. With solutions like the
                            <b> Videowala Bus Stand </b> and 360° marketing
                            services, we aspire to redefine how brands engage
                            with their audiences - leaving a lasting impact
                            across all touchpoints.
                          </p>
                          <br />
                          <p>
                            {" "}
                            Our ultimate goal is to be recognized not just as an
                            advertising company, but as a partner in every
                            client’s success story.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurMission;
